export const renderTableHeader = (moduleId, view) => {
    switch (moduleId) {
      case 1:
        switch (view) {
          case "Summary":
            return [
              {
                label: "Sl.No",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "5%",
                textAlign: "center",
              },
              {
                label: "Section",
                width: "w-[21%]",
                headerAlign: "center",
                rowAlign: "text-left",
                fieldname: "section",
                headone: "Section",
                type: "text",
                pdfWidth: "21%",
                textAlign: "left",
              },
              {
                label: "Sub - Section",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "section_no",
                feildnametwo: "sub_section_no",
                headone: "Sub - Section",
                type: "text",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Questions / Activity",
                width: "w-[27%]",
                headerAlign: "center",
                rowAlign: "text-left",
                fieldname: "question_activity",
                headone: "Questions / Activity",
                type: "text",
                pdfWidth: "27%",
                textAlign: "left",
              },
              {
                label: "Completion Date",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "completion_date",
                type: "date",
                headone: "Completion Date",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Status",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status_name",
                type: "text",
                headone: "Status",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Artefact",
                width: "w-[7%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "attachment",
                type: "file",
                headone: "Artefact",
                pdfWidth: "7%",
                textAlign: "center",
              },
            ];
          case "Detailed":
            return [
              {
                label: "Sl.No",
                width: "w-[4%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "4%",
                textAlign: "center",
              },
              {
                label: "Section",
                width: "w-[15%]",
                headerAlign: "center",
                rowAlign: "text-left",
                fieldname: "section",
                headone: "Section",
                type: "text",
                pdfWidth: "15%",
                textAlign: "left",
              },
              {
                label: "Sub - Section",
                width: "w-[7%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "section_no",
                feildnametwo: "sub_section_no",
                type: "text",
                headone: "Sub - Section",
                pdfWidth: "7%",
                textAlign: "center",
              },
              {
                label: "Questions / Activity",
                width: "w-[18%]",
                headerAlign: "center",
                rowAlign: "text-left",
                fieldname: "question_activity",
                type: "text",
                headone: "Questions / Activity",
                pdfWidth: "18%",
                textAlign: "left",
              },
              {
                label: "User Response",
                width: "w-[12%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "user_response",
                type: "text",
                headone: "User Response",
                pdfWidth: "12%",
                textAlign: "center",
              },
              {
                label: "User Comment",
                width: "w-[12%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "user_comment",
                type: "text",
                headone: "User Comment",
                pdfWidth: "12%",
                textAlign: "center",
              },
              {
                label: "Completion Date",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "completion_date",
                type: "date",
                headone: "Completion Date",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Status",
                width: "w-[7%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status_name",
                type: "text",
                headone: "Status",
                pdfWidth: "7%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Artefact",
                width: "w-[6%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "attachment",
                type: "file",
                headone: "Artefact",
                pdfWidth: "6%",
                textAlign: "center",
              },
            ];
          default:
            return [];
        }
      case 2:
        switch (view) {
          case "Summary":
            return [
              {
                label: "Sl.No",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "5%",
                textAlign: "center",
              },
              {
                label: "Section",
                width: "w-[11%]",
                headerAlign: "center",
                rowAlign: "text-left",
                fieldname: "section",
                headone: "Section",
                type: "text",
                pdfWidth: "11%",
                textAlign: "left",
              },
              {
                label: "Sub - Section",
                width: "w-[8%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "section_no",
                feildnametwo: "sub_section_no",
                headone: "Sub - Section",
                type: "text",
                pdfWidth: "8%",
                textAlign: "center",
              },
              {
                label: "Questions / Activity",
                width: "w-[17%]",
                headerAlign: "center",
                rowAlign: "text-left",
                fieldname: "question_activity",
                headone: "Questions / Activity",
                type: "text",
                pdfWidth: "17%",
                textAlign: "left",
              },
              {
                label: "Completion Date",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "completion_date",
                type: "date",
                headone: "Completion Date",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Status",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status_name",
                type: "text",
                headone: "Status",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Conformity Status",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "confirmative_status",
                type: "text",
                headone: "Conformity Status",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Definition",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status_definition",
                type: "text",
                headone: "Definition",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[12%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "12%",
                textAlign: "center",
              },
              {
                label: "Artefact",
                width: "w-[7%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "attachment",
                type: "file",
                headone: "Artefact",
                pdfWidth: "7%",
                textAlign: "center",
              },
            ];
          case "Detailed":
            return [
              {
                label: "Sl.No",
                width: "w-[4%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "4%",
                textAlign: "center",
              },
              {
                label: "Section",
                width: "w-[8%]",
                headerAlign: "center",
                rowAlign: "text-left",
                fieldname: "section",
                headone: "Section",
                type: "text",
                pdfWidth: "8%",
                textAlign: "left",
              },
              {
                label: "Sub - Section",
                width: "w-[7%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "section_no",
                feildnametwo: "sub_section_no",
                headone: "Sub - Section",
                type: "text",
                pdfWidth: "7%",
                textAlign: "center",
              },
              {
                label: "Questions / Activity",
                width: "w-[16%]",
                headerAlign: "center",
                rowAlign: "text-left",
                fieldname: "question_activity",
                headone: "Questions / Activity",
                type: "text",
                pdfWidth: "16%",
                textAlign: "left",
              },
              {
                label: "User Response",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "user_response",
                headone: "User Response",
                type: "text",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "User Comment",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "user_comment",
                headone: "User Comment",
                type: "text",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Completion Date",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "completion_date",
                type: "date",
                headone: "Completion Date",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Status",
                width: "w-[7%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status_name",
                type: "text",
                headone: "Status",
                pdfWidth: "7%",
                textAlign: "center",
              },
              {
                label: "Conformity Status",
                width: "w-[7%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "confirmative_status",
                type: "text",
                headone: "Conformity Status",
                pdfWidth: "7%",
                textAlign: "center",
              },
              {
                label: "Definition",
                width: "w-[7%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status_definition",
                type: "text",
                headone: "Definition",
                pdfWidth: "7%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Artefact",
                width: "w-[6%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "attachment",
                type: "file",
                headone: "Artefact",
                pdfWidth: "6%",
                textAlign: "center",
              },
            ];
          default:
            return [];
        }
      case 3:
        switch (view) {
          case "Summary":
            return [
              {
                label: "Sl.No",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "5%",
                textAlign: "center",
              },
              {
                label: "Maintenance Task",
                width: "w-[30%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "task",
                type: "text",
                headone: "Maintenance Task",
                pdfWidth: "30%",
                textAlign: "center",
              },
              {
                label: "Frequency",
                width: "w-[15%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "frequency_name",
                type: "text",
                headone: "Frequency",
                pdfWidth: "15%",
                textAlign: "center",
              },
              {
                label: "Comments",
                width: "w-[20%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "comments",
                type: "text",
                headone: "Comments",
                pdfWidth: "20%",
                textAlign: "center",
              },
              {
                label: "Status",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status",
                type: "text",
                headone: "Status",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Artefact",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "attachment",
                type: "file",
                headone: "Artefact",
                pdfWidth: "10%",
                textAlign: "center",
              },
            ];
          case "Detailed":
            return [
              {
                label: "Sl.No",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "5%",
                textAlign: "center",
              },
              {
                label: "Maintenance Task",
                width: "w-[30%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "task",
                type: "text",
                headone: "Maintenance Task",
                pdfWidth: "30%",
                textAlign: "center",
              },
              {
                label: "Frequency",
                width: "w-[15%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "frequency_name",
                type: "text",
                headone: "Frequency",
                pdfWidth: "15%",
                textAlign: "center",
              },
              {
                label: "Comments",
                width: "w-[20%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "comments",
                type: "text",
                headone: "Comments",
                pdfWidth: "20%",
                textAlign: "center",
              },
              {
                label: "Status",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status",
                type: "text",
                headone: "Status",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Artefact",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "attachment",
                type: "file",
                headone: "Artefact",
                pdfWidth: "10%",
                textAlign: "center",
              },
            ];
          default:
            return [];
        }
      case 4:
        switch (view) {
          case "Summary":
            return [
              {
                label: "Sl.No",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "5%",
                textAlign: "center",
              },
              {
                label: "Document Name",
                width: "w-[30%]",
                headerAlign: "center",
                rowAlign: "text-left",
                fieldname: "document_name",
                type: "text",
                headone: "Document Name",
                pdfWidth: "30%",
                textAlign: "left",
              },
              {
                label: "Document Description",
                width: "w-[15%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "document_description",
                type: "text",
                headone: "Document Description",
                pdfWidth: "20%",
                textAlign: "center",
              },
              {
                label: "Version",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "version",
                type: "text",
                headone: "Version",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Latest Updated",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "latest_update",
                type: "date",
                headone: "Latest Updated",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Status",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status",
                type: "text",
                headone: "Status",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Artefact",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "attachment",
                type: "file",
                headone: "Artefact",
                pdfWidth: "10%",
                textAlign: "center",
              },
            ];
          case "Detailed":
            return [
              {
                label: "Sl.No",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "5%",
                textAlign: "center",
              },
              {
                label: "Document Name",
                width: "w-[30%]",
                headerAlign: "center",
                rowAlign: "text-left",
                fieldname: "document_name",
                type: "text",
                headone: "Document Name",
                pdfWidth: "30%",
                textAlign: "left",
              },
              {
                label: "Document Description",
                width: "w-[15%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "document_description",
                type: "text",
                headone: "Document Description",
                pdfWidth: "20%",
                textAlign: "center",
              },
              {
                label: "Version",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "version",
                type: "text",
                headone: "Version",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Latest Updated",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "latest_update",
                type: "date",
                headone: "Latest Updated",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Status",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status",
                type: "text",
                headone: "Status",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Artefact",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "attachment",
                type: "file",
                headone: "Artefact",
                pdfWidth: "10%",
                textAlign: "center",
              },
            ];
          default:
            return [];
        }
      case 6:
        switch (view) {
          case "Summary":
            return [
              {
                label: "Sl.No",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "5%",
                textAlign: "center",
              },
              {
                label: "Ref Number",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "reference_number",
                type: "text",
                headone: "Ref Number",
                pdfWidth: "5%",
                textAlign: "center",
              },
              {
                label: "Performed By",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "performed_by",
                type: "text",
                headone: "Performed By",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Process Description",
                width: "w-[13%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "process_description",
                type: "text",
                headone: "Process Description",
                pdfWidth: "13%",
                textAlign: "center",
              },
              {
                label: "Audit Description",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "audit_description",
                type: "text",
                headone: "Audit Description",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Auditee",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "auditee",
                type: "text",
                headone: "Auditee",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Start Date",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "start_date",
                type: "date",
                headone: "Start Date",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "End Date",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "end_date",
                type: "date",
                headone: "End Date",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Status",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status",
                type: "text",
                headone: "Status",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Results",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "result",
                type: "text",
                headone: "Results",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_by_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Artefact",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "attachment",
                type: "file",
                headone: "Artefact",
                pdfWidth: "5%",
                textAlign: "center",
              },
            ];
          case "Detailed":
            return [
              {
                label: "Sl.No",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "5%",
                textAlign: "center",
              },
              {
                label: "Ref Number",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "reference_number",
                type: "text",
                headone: "Ref Number",
                pdfWidth: "5%",
                textAlign: "center",
              },
              {
                label: "Performed By",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "performed_by",
                type: "text",
                headone: "Performed By",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Process Description",
                width: "w-[13%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "process_description",
                type: "text",
                headone: "Process Description",
                pdfWidth: "13%",
                textAlign: "center",
              },
              {
                label: "Audit Description",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "audit_description",
                type: "text",
                headone: "Audit Description",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Auditee",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "auditee",
                type: "text",
                headone: "Auditee",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Start Date",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "start_date",
                type: "date",
                headone: "Start Date",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "End Date",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "end_date",
                type: "date",
                headone: "End Date",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Status",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status",
                type: "text",
                headone: "Status",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Results",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "result",
                type: "text",
                headone: "Results",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[9%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_by_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "9%",
                textAlign: "center",
              },
              {
                label: "Artefact",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "attachment",
                type: "file",
                headone: "Artefact",
                pdfWidth: "5%",
                textAlign: "center",
              },
            ];
          default:
            return [];
        }
      case 10:
        switch (view) {
          case "Summary":
            return [
              {
                label: "Sl.No",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "5%",
                textAlign: "center",
              },
              {
                label: "Task",
                width: "w-[15%]",
                headerAlign: "center",
                rowAlign: "text-left",
                fieldname: "task_id",
                type: "module",
                headone: "Task",
                pdfWidth: "15%",
                textAlign: "left",
              },
              {
                label: "Title",
                width: "w-[20%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "title",
                type: "text",
                headone: "Title",
                pdfWidth: "20%",
                textAlign: "center",
              },
              {
                label: "Comments",
                width: "w-[18%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "comment",
                type: "text",
                headone: "Comments",
                pdfWidth: "18%",
                textAlign: "center",
              },
              {
                label: "Completion Date",
                width: "w-[11%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "completion_date",
                type: "date",
                headone: "Completion Date",
                pdfWidth: "11%",
                textAlign: "center",
              },
              {
                label: "Reminder Date",
                width: "w-[11%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "reminder_date",
                type: "date",
                headone: "Reminder Date",
                pdfWidth: "11%",
                textAlign: "center",
              },
              {
                label: "Status",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status",
                type: "text",
                headone: "Status",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_name",
                feildnamethree: "created_by_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "10%",
                textAlign: "center",
              },
            ];
          case "Detailed":
            return [
              {
                label: "Sl.No",
                width: "w-[5%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "5%",
                textAlign: "center",
              },
              {
                label: "Task",
                width: "w-[15%]",
                headerAlign: "center",
                rowAlign: "text-left",
                fieldname: "task_id",
                type: "module",
                headone: "Task",
                pdfWidth: "15%",
                textAlign: "left",
              },
              {
                label: "Title",
                width: "w-[20%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "title",
                type: "text",
                headone: "Title",
                pdfWidth: "20%",
                textAlign: "center",
              },
              {
                label: "Comments",
                width: "w-[18%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "comment",
                type: "text",
                headone: "Comments",
                pdfWidth: "18%",
                textAlign: "center",
              },
              {
                label: "Completion Date",
                width: "w-[11%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "completion_date",
                type: "date",
                headone: "Completion Date",
                pdfWidth: "11%",
                textAlign: "center",
              },
              {
                label: "Reminder Date",
                width: "w-[11%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "reminder_date",
                type: "date",
                headone: "Reminder Date",
                pdfWidth: "11%",
                textAlign: "center",
              },
              {
                label: "Status",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "status",
                type: "text",
                headone: "Status",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "10%",
                textAlign: "center",
              },
            ];
          default:
            return [];
        }
      case 11:
        switch (view) {
          case "Summary":
            return [
              {
                label: "Sl.No",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Vendor Name",
                width: "w-[30%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "vendor_name",
                type: "text",
                headone: "Vendor Name",
                pdfWidth: "30%",
                textAlign: "center",
              },
              {
                label: "Vendor Type",
                width: "w-[20%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "vendor_type",
                type: "text",
                headone: "Vendor Type",
                pdfWidth: "20%",
                textAlign: "center",
              },
              {
                label: "Documents Type - NDA, SLA, Contract",
                width: "w-[20%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "attachment",
                type: "file",
                headone: "Documents Type - NDA, SLA, Contract",
                pdfWidth: "20%",
                textAlign: "center",
              },
              {
                label: "OnBoard Date",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "on_board_date",
                type: "date",
                headone: "OnBoard Date",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_name",
                feildnamethree: "created_by_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "10%",
                textAlign: "center",
              },
            ];
          case "Detailed":
            return [
              {
                label: "Sl.No",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "serial_number",
                headone: "Sl No.",
                type: "text",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Vendor Name",
                width: "w-[30%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "vendor_name",
                type: "text",
                headone: "Vendor Name",
                pdfWidth: "30%",
                textAlign: "center",
              },
              {
                label: "Vendor Type",
                width: "w-[20%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "vendor_type",
                type: "text",
                headone: "Vendor Type",
                pdfWidth: "20%",
                textAlign: "center",
              },
              {
                label: "Documents Type - NDA, SLA, Contract",
                width: "w-[20%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "attachment",
                type: "file",
                headone: "Documents Type - NDA, SLA, Contract",
                pdfWidth: "20%",
                textAlign: "center",
              },
              {
                label: "OnBoard Date",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "on_board_date",
                type: "date",
                headone: "OnBoard Date",
                pdfWidth: "10%",
                textAlign: "center",
              },
              {
                label: "Last Updated by",
                width: "w-[10%]",
                headerAlign: "center",
                rowAlign: "text-center",
                fieldname: "last_modified_name",
                feildnametwo: "created_name",
                feildnamethree: "created_by_name",
                type: "text",
                headone: "Last Updated by",
                pdfWidth: "10%",
                textAlign: "center",
              },
            ];
          default:
            return [];
        }
      case 12:
          switch (view) {
            case "Summary":
              return [
                {
                  label: "Sl.No",
                  width: "w-[5%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "serial_number",
                  headone: "Sl No.",
                  type: "text",
                  pdfWidth: "5%",
                  textAlign: "center",
                },
                {
                  label: "System",
                  width: "w-[15%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "systems",
                  type: "text",
                  headone: "System",
                  pdfWidth: "15%",
                  textAlign: "center",
                },
                {
                  label: "Incident Date",
                  width: "w-[9%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "incident_date",
                  type: "date",
                  headone: "Incident Date",
                  pdfWidth: "9%",
                  textAlign: "center",
                },
                {
                  label: "Closure Date",
                  width: "w-[9%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "closure_date",
                  type: "date",
                  headone: "Closure Date",
                  pdfWidth: "9%",
                  textAlign: "center",
                },
                {
                  label: "Type of Incident",
                  width: "w-[12%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "type_of_incident",
                  type: "text",
                  headone: "Type of Incident",
                  pdfWidth: "12%",
                  textAlign: "center",
                },
                {
                  label: "RCA Information / Analysis",
                  width: "w-[15%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "RCA",
                  type: "text",
                  headone: "RCA Information / Analysis",
                  pdfWidth: "15%",
                  textAlign: "center",
                },
                {
                  label: "Status Update",
                  width: "w-[10%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "status",
                  type: "text",
                  headone: "Status Update",
                  pdfWidth: "10%",
                  textAlign: "center",
                },
                {
                  label: "Last Updated by",
                  width: "w-[10%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "last_modified_name",
                  feildnametwo: "created_name",
                  feildnamethree: "created_by_name",
                  type: "text",
                  headone: "Last Updated by",
                  pdfWidth: "10%",
                  textAlign: "center",
                },
                {
                  label: "Incident Report / ATR Report",
                  width: "w-[15%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "attachment",
                  type: "file",
                  headone: "Incident Report / ATR Report",
                  pdfWidth: "15%",
                  textAlign: "center",
                },
              ];
            case "Detailed":
              return [
                {
                  label: "Sl.No",
                  width: "w-[5%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "serial_number",
                  headone: "Sl No.",
                  type: "text",
                  pdfWidth: "5%",
                  textAlign: "center",
                },
                {
                  label: "System",
                  width: "w-[15%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "systems",
                  type: "text",
                  headone: "System",
                  pdfWidth: "15%",
                  textAlign: "center",
                },
                {
                  label: "Incident Date",
                  width: "w-[9%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "incident_date",
                  type: "date",
                  headone: "Incident Date",
                  pdfWidth: "9%",
                  textAlign: "center",
                },
                {
                  label: "Closure Date",
                  width: "w-[9%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "closure_date",
                  type: "date",
                  headone: "Closure Date",
                  pdfWidth: "9%",
                  textAlign: "center",
                },
                {
                  label: "Type of Incident",
                  width: "w-[12%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "type_of_incident",
                  type: "text",
                  headone: "Type of Incident",
                  pdfWidth: "12%",
                  textAlign: "center",
                },
                {
                  label: "RCA Information / Analysis",
                  width: "w-[15%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "RCA",
                  type: "text",
                  headone: "RCA Information / Analysis",
                  pdfWidth: "15%",
                  textAlign: "center",
                },
                {
                  label: "Status Update",
                  width: "w-[10%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "status",
                  type: "text",
                  headone: "Status Update",
                  pdfWidth: "10%",
                  textAlign: "center",
                },
                {
                  label: "Last Updated by",
                  width: "w-[10%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "last_modified_name",
                  feildnametwo: "created_name",
                  feildnamethree: "created_by_name",
                  type: "text",
                  headone: "Last Updated by",
                  pdfWidth: "10%",
                  textAlign: "center",
                },
                {
                  label: "Incident Report / ATR Report",
                  width: "w-[15%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "attachment",
                  type: "file",
                  headone: "Incident Report / ATR Report",
                  pdfWidth: "15%",
                  textAlign: "center",
                },
              ];
            default:
              return [];
          }
      case 16:
          switch (view) {
            case "Summary":
              return [
                {
                  label: "Sl.No",
                  width: "w-[5%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "serial_number",
                  headone: "Sl No.",
                  type: "text",
                  pdfWidth: "5%",
                  textAlign: "center",
                },
                {
                  label: "Training Program",
                  width: "w-[12%]",
                  headerAlign: "center",
                  rowAlign: "text-left",
                  fieldname: "training_program",
                  type: "text",
                  headone: "Training Program",
                  pdfWidth: "12%",
                  textAlign: "left",
                },
                {
                  label: "Function Responsibility",
                  width: "w-[12%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "function_responsibility",
                  type: "text",
                  headone: "Function Responsibility",
                  pdfWidth: "12%",
                  textAlign: "center",
                },
                {
                  label: "Frequency",
                  width: "w-[8%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "frequency",
                  type: "text",
                  headone: "Frequency",
                  pdfWidth: "8%",
                  textAlign: "center",
                },
                {
                  label: "Participants",
                  width: "w-[10%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "participants",
                  type: "text",
                  headone: "Participants",
                  pdfWidth: "10%",
                  textAlign: "center",
                },
                {
                  label: "Mandatory for the organization",
                  width: "w-[12%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "mandatory",
                  type: "text",
                  headone: "Mandatory for \n the organization",
                  pdfWidth: "12%",
                  textAlign: "center",
                },
                {
                  label: "Detail Plan",
                  width: "w-[10%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "detail_plan",
                  type: "text",
                  headone: "Detail Plan",
                  pdfWidth: "10%",
                  textAlign: "center",
                },
                {
                  label: "Planned Date",
                  width: "w-[8%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "planned_date",
                  type: "date",
                  headone: "Planned Date",
                  pdfWidth: "8%",
                  textAlign: "center",
                },
                {
                  label: "Status",
                  width: "w-[8%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "status",
                  type: "text",
                  headone: "Status",
                  pdfWidth: "8%",
                  textAlign: "center",
                },
                {
                  label: "Last Updated by",
                  width: "w-[10%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "last_modified_name",
                  feildnametwo: "created_name",
                  feildnamethree: "created_by_name",
                  type: "text",
                  headone: "Last Updated by",
                  pdfWidth: "10%",
                  textAlign: "center",
                },
                {
                  label: "Artefact",
                  width: "w-[5%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "attachment",
                  type: "text",
                  headone: "Artefact",
                  pdfWidth: "5%",
                  textAlign: "center",
                },
              ];
            case "Detailed":
              return [
                {
                  label: "Sl.No",
                  width: "w-[5%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "serial_number",
                  headone: "Sl No.",
                  type: "text",
                  pdfWidth: "5%",
                  textAlign: "center",
                },
                {
                  label: "Training Program",
                  width: "w-[12%]",
                  headerAlign: "center",
                  rowAlign: "text-left",
                  fieldname: "training_program",
                  type: "text",
                  headone: "Training Program",
                  pdfWidth: "12%",
                  textAlign: "left",
                },
                {
                  label: "Function Responsibility",
                  width: "w-[12%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "function_responsibility",
                  type: "text",
                  headone: "Function Responsibility",
                  pdfWidth: "12%",
                  textAlign: "center",
                },
                {
                  label: "Frequency",
                  width: "w-[8%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "frequency",
                  type: "text",
                  headone: "Frequency",
                  pdfWidth: "8%",
                  textAlign: "center",
                },
                {
                  label: "Participants",
                  width: "w-[10%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "participants",
                  type: "text",
                  headone: "Participants",
                  pdfWidth: "10%",
                  textAlign: "center",
                },
                {
                  label: "Mandatory for the organization",
                  width: "w-[12%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "mandatory",
                  type: "text",
                  headone: "Mandatory for the organization",
                  pdfWidth: "12%",
                  textAlign: "center",
                },
                {
                  label: "Detail Plan",
                  width: "w-[10%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "detail_plan",
                  type: "text",
                  headone: "Detail Plan",
                  pdfWidth: "10%",
                  textAlign: "center",
                },
                {
                  label: "Planned Date",
                  width: "w-[8%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "planned_date",
                  type: "date",
                  headone: "Planned Date",
                  pdfWidth: "8%",
                  textAlign: "center",
                },
                {
                  label: "Status",
                  width: "w-[8%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "status",
                  type: "text",
                  headone: "Status",
                  pdfWidth: "8%",
                  textAlign: "center",
                },
                {
                  label: "Last Updated by",
                  width: "w-[10%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "last_modified_name",
                  feildnametwo: "created_name",
                  feildnamethree: "created_by_name",
                  type: "text",
                  headone: "Last Updated by",
                  pdfWidth: "10%",
                  textAlign: "center",
                },
                {
                  label: "Artefact",
                  width: "w-[5%]",
                  headerAlign: "center",
                  rowAlign: "text-center",
                  fieldname: "attachment",
                  type: "text",
                  headone: "Artefact",
                  pdfWidth: "5%",
                  textAlign: "center",
                },
              ];
            default:
              return [];
          }
      case 18:
            switch (view) {
              case "Summary":
                return [
                  {
                    label: "Sl.No",
                    width: "w-[7%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "serial_number",
                    headone: "Sl No.",
                    type: "text",
                    pdfWidth: "7%",
                    textAlign: "center",
                  },
                  {
                    label: "Heading",
                    width: "w-[18%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "heading",
                    type: "text",
                    headone: "Heading",
                    pdfWidth: "18%",
                    textAlign: "center",
                  },
                  {
                    label: "Group",
                    width: "w-[15%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "group_data",
                    type: "text",
                    headone: "Group",
                    pdfWidth: "15%",
                    textAlign: "center",
                  },
                  {
                    label: "Date",
                    width: "w-[10%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "mom_date",
                    type: "date",
                    headone: "Date",
                    pdfWidth: "10%",
                    textAlign: "center",
                  },
                  {
                    label: "Type of Meeting",
                    width: "w-[20%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "type_of_meeting",
                    type: "text",
                    headone: "Type of Meeting",
                    pdfWidth: "20%",
                    textAlign: "center",
                  },
                  {
                    label: "Status",
                    width: "w-[10%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "status",
                    type: "text",
                    headone: "Status",
                    pdfWidth: "10%",
                    textAlign: "center",
                  },
                  {
                    label: "Last Updated by",
                    width: "w-[10%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "last_modified_name",
                    feildnametwo: "created_name",
                    feildnamethree: "created_by_name",
                    type: "text",
                    headone: "Last Updated by",
                    pdfWidth: "10%",
                    textAlign: "center",
                  },
                  {
                    label: "Artefact",
                    width: "w-[10%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "attachment",
                    type: "file",
                    headone: "Artefact",
                    pdfWidth: "10%",
                    textAlign: "center",
                  },
                ];
              case "Detailed":
                return [
                  {
                    label: "Sl.No",
                    width: "w-[4%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "serial_number",
                    headone: "Sl No.",
                    type: "text",
                    pdfWidth: "4%",
                    textAlign: "center",
                  },
                  {
                    label: "Heading",
                    width: "w-[11%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "heading",
                    type: "text",
                    headone: "Heading",
                    pdfWidth: "11%",
                    textAlign: "center",
                  },
                  {
                    label: "Group",
                    width: "w-[10%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "group_data",
                    type: "text",
                    headone: "Group",
                    pdfWidth: "10%",
                    textAlign: "center",
                  },
                  {
                    label: "Date",
                    width: "w-[7%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "mom_date",
                    type: "date",
                    headone: "Date",
                    pdfWidth: "7%",
                    textAlign: "center",
                  },
                  {
                    label: "Type of Meeting",
                    width: "w-[10%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "type_of_meeting",
                    type: "text",
                    headone: "Type of Meeting",
                    pdfWidth: "10%",
                    textAlign: "center",
                  },
                  {
                    label: "Regrets",
                    width: "w-[10%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "regrets",
                    type: "text",
                    headone: "Type of Meeting",
                    pdfWidth: "10%",
                    textAlign: "center",
                  },
                  {
                    label: "Chaired By",
                    width: "w-[12.5%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "chaired_by",
                    type: "text",
                    headone: "Chaired By",
                    pdfWidth: "12.5%",
                    textAlign: "center",
                  },
                  {
                    label: "Minutes By",
                    width: "w-[12.5%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "minute_by",
                    type: "text",
                    headone: "Minutes By",
                    pdfWidth: "12.5%",
                    textAlign: "center",
                  },
                  {
                    label: "Status",
                    width: "w-[7%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "status",
                    type: "text",
                    headone: "Status",
                    pdfWidth: "7%",
                    textAlign: "center",
                  },
                  {
                    label: "Last Updated by",
                    width: "w-[10%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "last_modified_name",
                    feildnametwo: "created_name",
                    feildnamethree: "created_by_name",
                    type: "text",
                    headone: "Last Updated by",
                    pdfWidth: "10%",
                    textAlign: "center",
                  },
                  {
                    label: "Artefact",
                    width: "w-[6%]",
                    headerAlign: "center",
                    rowAlign: "text-center",
                    fieldname: "attachment",
                    type: "file",
                    headone: "Artefact",
                    pdfWidth: "6%",
                    textAlign: "center",
                  },
                ];
              default:
                return [];
            }
      default:
        return [];
    }
  };